import './js/scroll-top-btn.js';
import './js/theme-switcher.js';
import './js/modal-signUp-login';
import './js/support-companies.js';
import './js/mobile-menu';
import './js/loader.js';
// shopping basket js files
// import './js/shopping-list.js';
import './js/shopping-list-for-merge.js'
import './js/support-list-swiper.js';
import './js/header-change.js';


